import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

import { watch, onMounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BsPlaceholder',
  props: {
    pattern: {}
  },
  setup(__props: any) {

const props = __props

const gridTemplateAreas = ref<string>('')
const gridAreas = ref<string[]>([])

watch(() => props.pattern, parsePattern)
onMounted(() => parsePattern(props.pattern))

function parsePattern(pattern: string) {
  const rows = pattern.split(' ')

  const areaTemplateRows: string[] = []
  const uniqueAreas = new Set<string>()
  for (let rIndex = 0; rIndex < rows.length; rIndex++) {
    const col = rows[rIndex]
    const parsed = (col + '............').substring(0, 12).replace(/[^.]/ig, '#')
    const rowAreaTemplate: string[] = []

    const groups = parsed.match(/([^.]+|\.+)/ig) ?? []

    for (let gIndex = 0; gIndex < groups.length; gIndex++) {
      if (groups[gIndex][0] === '.') {
        rowAreaTemplate.push(...Array.from(groups[gIndex]).map(() => '.'))
      } else {
        const item = `a-${rIndex}-${gIndex}`
        rowAreaTemplate.push(...Array.from(groups[gIndex]).map(() => item))
        uniqueAreas.add(item)
      }
    }
    areaTemplateRows.push(`"${rowAreaTemplate.join(' ')}"`)
  }
  gridTemplateAreas.value = areaTemplateRows.join(' ')
  gridAreas.value = Array.from(uniqueAreas)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "bs-placeholder",
    style: _normalizeStyle({ gridTemplateAreas: gridTemplateAreas.value })
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gridAreas.value, (gridArea, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        style: _normalizeStyle({ gridArea }),
        class: "bs-placeholder__area"
      }, null, 4))
    }), 128))
  ], 4))
}
}

})